"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieBanner = void 0;
var react_1 = __importDefault(require("react"));
var CookieBanner = function (_a) {
    var children = _a.children, onPreferencesClick = _a.onPreferencesClick, onAccept = _a.onAccept, className = _a.className;
    return (react_1.default.createElement("div", { className: "axxes-cookie-banner ".concat(className || '') },
        react_1.default.createElement("div", { className: 'axxes-cookie-banner__text-container' }, children ? (children) : (react_1.default.createElement("p", { id: 'default-text' },
            "We gebruiken cookies om je een betere bezoekerservaring te bieden. Lees meer in",
            " ",
            react_1.default.createElement("a", { href: 'http://www.axxes.com/privacy-cookies' }, "de cookie policy"),
            "."))),
        react_1.default.createElement("div", { className: 'axxes-cookie-banner__button-container' },
            onPreferencesClick && (react_1.default.createElement("button", { id: 'preferences', onClick: onPreferencesClick }, "Voorkeuren")),
            react_1.default.createElement("button", { id: 'accept', onClick: onAccept }, "That's okay"))));
};
exports.CookieBanner = CookieBanner;
